import { BASE_URL } from '../urls';

export const sendFeedback = (options, callback) => {
  return (dispatch, getState) => {
    fetch(`${BASE_URL}/feedback`, {
      method: 'POST',
      headers: {
        Authorization: getState().auth.token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(options)
    }).then(callback);
  }
}